import React from 'react'
import { setDocumentTitle } from '@isdd/metais-common/utils/utils'
import { useParams } from 'react-router-dom'
import { useTranslation } from 'react-i18next'

import { RelationTypeListContainer } from '@/components/containers/RelationTypeListContainer'
import { RelationTypeListView } from '@/components/views/relation-type-list/RelationTypeListView'

const RelationTypePage: React.FC = () => {
    const { relationType } = useParams()
    const { t } = useTranslation()
    setDocumentTitle(t(`titles.relation.${relationType}`))
    return <RelationTypeListContainer View={(props) => <RelationTypeListView {...props} />} />
}

export default RelationTypePage
